import ax from 'axios'
import olineAuth from 'oline_auth'
import store from '@/store'

const MAX_AUTH_RETRIES = 2
const AUTH_URL_PREFIX = '/api/auth/'

export const axios = ax

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
axios.defaults.headers.common['Content-Type'] = 'application/json'
axios.defaults.headers.common['Accept'] = 'application/json'

export const auth = olineAuth.apply(axios)

axios.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  const status = error?.response?.status;
  const config = error?.config;

  const isAuthRequest = String(config?.url ?? '').includes(AUTH_URL_PREFIX);

  if (status === 401 && config && config.noAuthRetry !== true && !isAuthRequest) {
    config._authRetries = (config._authRetries || 0) + 1;

    store.dispatch('auth/unauthorized');

    if (config._authRetries <= MAX_AUTH_RETRIES) {
      return store.dispatch('auth/retryAfterAuth', config);
    }
  }

  if (status === 502) {
    store.dispatch('shared/setError', {
      errors: null,
      message: 'Повторите попытку через несколько секунд, до тех пор, пока она не завершится успехом',
      status: 'error'
    });
  }

  return Promise.reject(error);
});

export default {
  install (Vue) {
    Vue.prototype.$axios = axios
  }
}
